<script setup lang="ts">
import type { Link } from "@/schemas/link";

defineProps<{ link: Link }>();
</script>

<template>
  <a :href="link.url" :target="link.target" :class="link.class">{{ link.title }}</a>
</template>
